export * from "./ToteBetsApiCalculateBetsBet";
//# sourceMappingURL=index.js.map